import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styles from './index.css';

/**
 * for this page
 */
import Tab from '../tab';
import Table from '../../../../components/table';
import Pagination from '../../../../components/pagination';

import { getDeclareTableData } from '../../../../../../../services/api';
import columnsTemp from './columnsTemp';
class DataTable extends React.PureComponent {
    static propTypes = {};

    state = {
        data: null,
        columns: [],
        list: [],
        disp: 0,
        type: 'all',
        total: 0,
        psize: 20,
    };

    // 切换类型
    handleSwitch = index => {
        this.setState(
            {
                type: index ? 'kcb' : 'all',
            },
            () => {
                this.asyncGetTableData(1, this.state.psize, this.state.disp, this.state.type);
                this.resetPagination();
            },
        );
    };

    handleDispChange = disp => {
        if (this.state !== disp) {
            this.setState(
                {
                    disp,
                },
                () => {
                    this.asyncGetTableData(1, this.state.psize, this.state.disp, this.state.type);
                    this.resetPagination();
                },
            );
        }
    };

    componentDidMount = () => {
        this.asyncGetTableData(1, this.state.psize, 0, this.state.type);
        this.formatColumns();
    };

    // 获取数据
    asyncGetTableData = async (pno, sort, psize, disp, type) => {
        const data = await getDeclareTableData(pno, sort, psize, disp, type);

        // console.log(data);

        if (data) {
            this.setState(
                {
                    data,
                    total: data.total,
                },
                () => {
                    this.formatList(data.head, data.body);
                },
            );
        }
    };

    // 格式化表头
    formatColumns = () => {
        const res = columnsTemp.map(item => {
            if (item.name === 'No') {
                return {
                    title: item.title,
                    dataIndex: item.name,
                    width: 50,
                };
            }

            if (item.name === 'PlateName') {
                return {
                    title: item.title,
                    dataIndex: item.name,
                    width: 85,
                };
            }
            if (item.name === 'CompanyName') {
                return {
                    title: item.title,
                    dataIndex: item.name,
                    width: 190,
                    render: (text, record, title, index) => {
                        if (record.type === 'kcb' || record.type === '科创板') {
                            return (
                                <div style={{ padding: '10px 10px', textAlign: 'left' }}>
                                    <span style={{ color: '#e2524b' }}>【科】</span>
                                    {text}
                                </div>
                            );
                        } else {
                            return <div style={{ padding: '10px 10px', textAlign: 'left' }}>{text}</div>;
                        }
                    },
                };
            }
            if (
                item.name === 'CompanyName' ||
                item.name === 'SponsorName' ||
                item.name === 'AccountingFirm' ||
                item.name === 'LawFirm'
            ) {
                return {
                    title: item.title,
                    dataIndex: item.name,
                    width: 170,
                    render: (text, record, title, index) => {
                        return <div style={{ padding: '10px 10px', textAlign: 'left' }}>{text}</div>;
                    },
                };
            }

            return {
                title: item.title,
                dataIndex: item.name,
            };
        });

        this.setState({
            columns: res,
        });
    };

    // 格式化列表数据
    formatList = (head, body) => {
        const res = [];

        if (head && body) {
            body.forEach(item => {
                const obj = {};

                head.forEach((ele, i) => {
                    obj[ele] = item[i];
                });

                res.push(obj);
            });

            this.setState({
                list: res,
            });
        }
    };

    // 点击翻页
    handleChangePage = pagination => {
        this.asyncGetTableData(pagination.pageNumber, this.state.psize, this.state.disp, this.state.type);
    };

    onRef = child => {
        this.child = child;
    };

    resetPagination = () => {
        this.child.resetCur();
    };

    render() {
        const { columns, list, total } = this.state;

        return (
            <div className={styles.dataTable}>
                <Tab onChange={this.handleSwitch} onDispChange={this.handleDispChange} />
                <div style={{ paddingTop: 14 }}>
                    <Table columns={columns} dataSource={list} />
                </div>
                <div style={{ width: 400, margin: '50px auto 116px' }}>
                    <Pagination
                        current={1}
                        total={Number(total) || 0}
                        type={'simple'}
                        pageSize={this.state.psize}
                        onChange={this.handleChangePage}
                        showQuickJumper
                        onRef={this.onRef}
                    />
                </div>
            </div>
        );
    }
}

export default DataTable;
